<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("cinematypes") }}</div>
        <div class="section-subTitle my-2">
          Manage All your Cinema Types here.
        </div>
      </div>
      <div>
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              filter_is_active = filterIsActive;
              getCinemaTypesList();
            }
          "
        />
        <b-button
          v-if="$can('create', 'Cinema Type')"
          variant="default"
          :to="{ name: 'Add Cinema Type' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header" style="justify-content: normal">
        <div class="pr-4">{{ $tc("status", 2) }}</div>

        <div>Cinema Types</div>
      </div>
      <ul class="desg-list" v-if="cinema_types_list.length > 0">
        <li
          v-for="(cinema_type, cinemaTypeKey) in cinema_types_list"
          :key="cinemaTypeKey"
          style="justify-content: normal"
          class="light_grey_back"
        >
          <!-- <div class="d-flex align-items-center">
            <StatusDot
              :status="
                cinema_type.cine_type_is_active == 'Y' ? 'active' : 'inactive'
              "
            />
            <b-dropdown right variant="edit" class="ml-2">
              <b-dropdown-item
                v-if="$can('update', 'Cinema Type')"
                :to="{
                  name: 'Edit Cinema Type',
                  params: { cinema_type_id: cinema_type.cinema_type_id },
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'View Cinema Type',
                  params: { cinema_type_id: cinema_type.cinema_type_id },
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div> -->
          <div class="d-flex align-items-center">
            <StatusDot
              :status="
                cinema_type.cine_type_is_active == 'Y' ? 'active' : 'inactive'
              "
            />
            <router-link
              v-if="$can('update', 'Cinema Type')"
              :to="{
                name: 'Edit Cinema Type',
                params: { cinema_type_id: cinema_type.cinema_type_id },
              }"
              class="edit-pen icon blue-icon cursor-pointer ml-2"
              v-b-tooltip="'Edit'"
              tabindex="0"
            ></router-link>
            <router-link
              :to="{
                name: 'View Cinema Type',
                params: { cinema_type_id: cinema_type.cinema_type_id },
              }"
              class="icon-eye blue-icon cursor-pointer ml-2"
              v-b-tooltip="'View'"
              tabindex="0"
            ></router-link>
          </div>
          <div class="ml-4">{{ cinema_type.cinema_type_name }}</div>
        </li>
      </ul>
      <ul class="desg-list" v-else>
        <li>
          <div class="w-100 text-center">{{ $t("NoRecords") }}</div>
        </li>
      </ul>
    </div>
    <br />
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      filter_is_active: "Y",
      cinema_types_list: [],
    };
  },
  mounted() {
    this.getCinemaTypesList();
  },
  methods: {
    getCinemaTypesList: function () {
      let payload = {
        filter_is_active: this.filter_is_active,
      };
      MasterService.GetCinemaTypesList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinema_types_list = data.Records;
          } else {
            this.cinema_types_list = [];
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTypeComponents/cinemaTypes.vue